import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CandidateReleaseFormComponent } from './employment-application.component';
import { LoadingModule } from 'ngx-loading';
// import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { ClickOutsideModule } from 'ng-click-outside';
export const routes = [
  { path: '', component: CandidateReleaseFormComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingModule,
    RouterModule.forChild(routes),
    // RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    MultiselectDropdownModule,
    ClickOutsideModule,
    NgbModule.forRoot()
  ],
  declarations: [CandidateReleaseFormComponent, FileUploaderComponent],
  exports: [FileUploaderComponent]
})

export class EmploymentApplicationModule { }


// WEBPACK FOOTER //
// E:/sachin/Project/Masterly_Solutions/Project_HRMS/Hrms_Developer/hrms/Peerless.HRMS.WebUI.EmployeePortal/src/app/pages/employment-application/employment-application.module.ts